<template>
  <div class="header">
    <div class="header-top">
      <div class="header-left">
        <div class="logo" v-if="homescreenImageUrl">
          <img v-bind:src="homescreenImageUrl" />
        </div>
      </div>

      <div class="header-right" v-show="isChatBoxOpen && isFullscreen">
        <div class="header-action-icon">
          <svg
            :class="[isChatBoxOpen ? 'fadeIn' : 'fadeOut']"
            :fill="textColour"
            class="close-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
        <div class="tooltip">
          <span class="tooltiptext">Close</span>
        </div>
      </div>
    </div>
    <div class="title">{{ greetingText }}</div>
    <div class="subtitle">{{ introductionText }}</div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { default as ColourPicker } from '@/shared/services/color';

const props = defineProps({
  brandColour: {
    type: String,
    required: true,
  },
  homescreenImageUrl: {
    type: String,
    default: true,
  },
  greetingText: {
    type: String,
    default: '',
  },
  introductionText: {
    type: String,
    default: '',
  },
});

const isChatBoxOpen = ref(true);
const isFullscreen = ref(false);
const textColour = computed(() => ColourPicker.getContrastingColour(props.brandColour));
</script>

<style lang="scss" scoped>
.header {
  padding: 1.5em 1.5em 1em 1.5em;

  .logo {
    width: 300px;
    height: 48px;
    margin-bottom: 16px;

    display: flex;
    align-items: flex-start;
    overflow: hidden;
  }

  .title {
    font-weight: 500;
    font-size: 1.75em;
  }

  .subtitle {
    font-size: 1.15em;
    opacity: 0.7;
  }
}
.header-top {
  display: flex;
}
.header-left {
  flex: 1;
}
.header-right {
  display: flex;
  justify-content: center;
  position: relative;
}

.header-action-icon {
  cursor: pointer;
  width: 3em;
  height: 3em;
  align-items: center;
  display: flex;
  justify-content: center;
  border-radius: 0.3em;
}

.header-action-icon:hover ~ .tooltip {
  transition: 200ms;
  transition-delay: 500ms;
  opacity: 1;
  visibility: visible;
}

.close-icon {
  width: 1.75em;
  height: 1.75em;
}

.tooltip {
  position: absolute;
  top: 3.5em;
  opacity: 0;
  visibility: hidden;

  .tooltiptext {
    background-color: rgba($color: #000000, $alpha: 0.8);
    color: #fff;
    border-radius: 0.25em;
    padding: 0.75em;
    word-break: normal;
    display: flex;
    align-items: center;
    text-align: center;

    &::after {
      content: ' ';
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      margin-top: -10px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent rgba(0, 0, 0, 0.8) transparent;
    }
  }
}
</style>
